<template>
  <div>
    <nav class="navbar shadow navbar-light bg-light">
      <router-link class="navbar-brand" :to="{ name: 'Home' }">e-commmerce</router-link>
      <form @submit.prevent="findData" class="form-inline" style="margin: 0px;">
        <input
          style="margin-right: 0px;"
          class="form-control mr-sm-2"
          type="search"
          v-model="searchItem"
          placeholder="Search"
          aria-label="Search"
        />
        <button
          style="margin-left: 0px;"
          class="btn btn-outline-success my-2 my-sm-0"
          type="submit"
        >Search</button>
      </form>
      <router-link :to="{ name: 'CartList' }">
        <svg
          width="2em"
          height="2em"
          viewBox="0 0 16 16"
          class="bi bi-cart-fill"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          color="#218838"
        >
          <path
            fill-rule="evenodd"
            d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
          />
        </svg>
      </router-link>
      <div v-if="!statusLogin">
        <button
          @click="login"
          type="button"
          class="btn border-success btn-light"
          style="color: green;"
        >Masuk</button>
        <button
          @click="register"
          style="margin-left: 20px;"
          type="button"
          class="btn border-light btn-success"
        >Daftar</button>
      </div>
      <div v-else class="dropdown" style="margin-right:30px;">
        <a
          class="dropdown-toggle"
          id="dropdownMenu2"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >Welcome, {{ emailUser }}</a>
        <div class="dropdown-menu dropdown-menu-left">
          <router-link class="dropdown-item" :to="{ name: 'History' }">See History</router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="logout">Logout</a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import swal from "sweetalert";

export default {
  data() {
    return {
      statusLogin: false,
      searchItem: ""
    };
  },
  methods: {
    findData() {
      const data = this.searchItem;
      console.log(data, "in data");
      this.$store.dispatch("searchData", data);
    },
    login() {
      this.$router.push({ name: "Login" });
    },
    register() {
      this.$router.push({ name: "Register" });
    },
    logout() {
      localStorage.clear();
      this.statusLogin = false;
      swal("Berhasil Logout!", "", "success");
      this.$router.push({ name: "Home" });
    }
  },
  computed: {
    emailUser: function() {
      return localStorage.emailUser;
    }
  },
  created() {
    console.log(this.statusLogin, "check status");
    console.log(localStorage.access_token, "ini token");
    if (!localStorage.access_token) {
      this.statusLogin = false;
    } else {
      this.statusLogin = true;
    }
  }
};
</script>

<style></style>
